var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "competition-cycle" },
    [
      !_vm.ready
        ? _c("div", { staticClass: "row mat32" }, [_vm._m(0)])
        : [
            _vm.submitSuccess
              ? _c("panel-info-box", [
                  _c("img", {
                    staticStyle: { "max-height": "48px" },
                    attrs: {
                      src: require("../assets/images/icons/checkmark-circle.svg"),
                    },
                  }),
                  _c("p", { staticClass: "text-lg" }, [
                    _c("b", [_vm._v(_vm._s(_vm.submitMessage))]),
                  ]),
                ])
              : _vm._e(),
            _c("panel-competition-cycle-form", {
              attrs: {
                "available-cycles": _vm.availableCycles,
                "assigned-cycle-id": _vm.assignedCycleId,
                errors: _vm.errors,
                loading: _vm.loading,
              },
              on: { save: _vm.save, detach: _vm.detach },
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "admin-header__loading-state" }, [
        _vm._v(" Trwa wczytywanie "),
        _c("div", { staticClass: "mal15 lds-ellipsis" }, [
          _c("div"),
          _c("div"),
          _c("div"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }